<template>
  <div class="demand-form-container">
    <div class="form-header">
      <h2>没有找到需要的零件?在这里通知我们!</h2>
      <p>请告诉我们您需要的产品信息</p>
    </div>
     <!-- dem_type 1:需求 2:建议   -->
    <el-form :model="localDemandForm" label-width="160px" class="demand-form">
      <el-row>
        <el-col :span="24">
          <el-form-item label="OE参考号">
            <el-input v-model="localDemandForm.oecode" placeholder="请输入OE参考号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="24">
          <el-form-item label="产品名称">
            <el-input v-model="localDemandForm.goods_name" placeholder="请输入产品名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="24">
          <el-form-item label="适用车型">
            <el-input v-model="localDemandForm.vehicletype" placeholder="请输入适用车型"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="24">
          <el-form-item label="您的产品年销量">
            <el-input v-model="localDemandForm.dem_num" placeholder="请输入您的产品年销量"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="24">
          <el-form-item label="请描述您对产品的改进建议及价格区间">
            <el-input 
              v-model="localDemandForm.parts_cri" 
              type="textarea" 
              :rows="4" 
              placeholder="请描述您对产品的改进建议及价格区间"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <!-- 图片上传 -->
      <el-form-item label="图片">
        <el-upload
          
          :action="$axios.defaults.baseURL+'index.php?act=upload&op=image'"
          :data="{store_id:this.$store.state.store_id}"
          :headers="{'token':$store.state.token}"
          name="image"
          list-type="picture-card"
          :on-success="upImgSuccess"
          :limit="9"
          :on-remove="(file)=>{fileDel(file,'imgList')}"
          multiple
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      
      <!-- 文件上传 -->
      <el-form-item label="附件">
        <el-upload
          :action="$axios.defaults.baseURL+'index.php?act=upload&op=image'"
          :data="{store_id:this.$store.state.store_id}"
          :headers="{'token':$store.state.token}"
          name="image"
          :on-success="upFileSuccess"
          :limit="9"
          :on-remove="(file)=>{fileDel(file,'fileList')}"
          multiple
        >
          <div 
            style="width: 80px; height: 28px; background-color: #063376; display: flex; align-items: center; justify-content: center; color: white; border-radius: 4px; cursor: pointer; font-size: 12px;"
          >
            点击上传
          </div>
        </el-upload>
      </el-form-item>
      
      <el-row>
        <div class="form-actions">
            <el-button type="primary" @click="submitDemand">提交</el-button>
        </div>
      </el-row>
      <!-- <el-form-item class="form-actions">
        <el-button @click="cancelDemand" v-if="showCancel">取消</el-button>
      </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
export default {
  name: "DemandForm",
  props: {
    // 是否显示取消按钮
    showCancel: {
      type: Boolean,
      default: false
    },
    // 初始表单数据
    formData: {
      type: Object,
      default: () => ({
        oecode: "",
        goods_name: "",
        vehicletype: "",
        dem_num: "",
        parts_cri: ""
      })
    }
  },
  data() {
    return {
      localDemandForm: { ...this.formData },
      // 上传文件列表
      fileList: [],
      imgList: []
    };
  },
  watch: {
    formData: {
      handler(newVal) {
        this.localDemandForm = { ...newVal };
      },
      deep: true
    }
  },
  methods: {
    // 图片上传成功回调
    upImgSuccess(res) {
      console.log("图片上传成功", res);
      this.imgList.push(res.data);
      // 将图片URL保存到表单数据中
      this.localDemandForm.img_name = this.imgList.map(item => item.url).join(",");
    },
    
    // 文件上传成功回调
    upFileSuccess(res, file) {
      console.log("文件上传成功", res, file);
      this.fileList.push({
        ...res.data,
        fileUrl: res.data.url,
        fileName: file.name
      });
      // 将文件URL保存到表单数据中（使用URL而不是文件名）
      this.localDemandForm.fullname = this.fileList.map(item => item.fileUrl).join(",");
    },
    
    // 文件删除回调
    fileDel(file, type = "imgList") {
      console.log("删除文件", file);
      this[type] = this[type].filter(item => item.url != file.response.data.url);
      
      // 更新表单数据
      if (type === "imgList") {
        this.localDemandForm.img_name = this.imgList.map(item => item.url).join(",");
      } else if (type === "fileList") {
        this.localDemandForm.fullname = this.fileList.map(item => item.fileUrl).join(",");
      }
      
      console.log("更新后的文件列表", this[type]);
    },
    
    // 提交需求
    async submitDemand() {
      try {
        const res = await this.$api.pubDemand({
          store_id: this.$store.state.store_id,
          store_name: this.$store.state.store_name,
          member_id: this.$store.state.member_id,
          member_name: this.$store.state.member_name,
          ...this.localDemandForm
        });
        
        if(res) {
          this.$suMsg("需求提交成功");
          // 重置表单
          this.resetDemandForm();
          // 触发提交成功事件
          this.$emit("submit-success", res);
          this.$router.push("/my/demand");
        } else {
          this.$erMsg("需求提交失败");
        } 
      } catch (error) {
        this.$erMsg("提交过程中出现错误");
      }
    },
    // 取消需求提交
    cancelDemand() {
      this.resetDemandForm();
      // 触发取消事件
      this.$emit("cancel");
    },
    // 重置表单
    resetDemandForm() {
      this.localDemandForm = {
        oecode: "",
        goods_name: "",
        vehicletype: "",
        dem_num: "",
        parts_cri: ""
      };
      // 清空上传列表
      this.imgList = [];
      this.fileList = [];
      // 清空表单中的上传字段
      this.localDemandForm.img_name = "";
      this.localDemandForm.fullname = "";
    },
    // 外部调用重置表单的方法
    resetForm() {
      this.resetDemandForm();
    },
    // 获取当前表单数据
    getFormData() {
      return { ...this.localDemandForm };
    }
  }
};
</script>

<style lang="scss" scoped>
.demand-form-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  background: #01944d;
  border-radius: 8px;
  
  .form-header {
    text-align: left;
    margin-bottom: 30px;
    
    h2 {
      color: #ffffff;
      font-size: 24px;
      margin-bottom: 10px;
    }
    p {
      color: #ffffff;
      font-size: 14px;
    }
  }
  
  .demand-form {
    margin-top: 20px;
    
    .el-form-item {
      margin-bottom: 15px;
      
       ::v-deep .el-form-item__label {
        color: #ffffff;
        font-weight: 500;
      }
      
      .el-input__inner, .el-textarea__inner {
        border-radius: 4px;
      }
    }
    
    .form-actions {
      text-align: center;
      margin-top: 10px;
      margin-bottom: 20px;
      
      .el-button {
        padding: 12px 30px;
        font-size: 16px;
        border-radius: 20px;
        margin: 0 10px;
      }
      
      .el-button--primary {
        color: #ffffff;
        background-color: #01944d;
        border: 1px solid #ffffff;
      }
    }
  }
}
</style>